import React from 'react';
import { Headline } from '@/components/headline/Headline';
import SerializeDescription from '@/components/serialize-description/SerializeDescription';
import { Link } from '@/components/link/Link';
import { VariantComponentProps } from '../types';

const BasicCta: React.FC<VariantComponentProps<'basic'>> = ({
  title,
  description,
  link,
}) => {
  return (
    <div className="flex w-full flex-col items-stretch justify-between gap-4 rounded-xl bg-neutral-0 px-6 py-6 shadow-sm sm:flex-row sm:items-center">
      <div className="flex min-w-0 flex-1 flex-col">
        {title && (
          <Headline
            variant="headingFour"
            title={title}
            className="!m-0 text-brand-700"
          />
        )}
        {description?.content && (
          <SerializeDescription
            description={description.content}
            className="mt-1 text-sm text-neutral-700"
          />
        )}
      </div>

      {link && <Link {...link} className="w-full !rounded-full sm:w-auto" />}
    </div>
  );
};

export default BasicCta;
